import { render } from "./CustomersFilterOption.vue?vue&type=template&id=e235fb98&scoped=true"
import script from "./CustomersFilterOption.vue?vue&type=script&lang=js"
export * from "./CustomersFilterOption.vue?vue&type=script&lang=js"

import "./CustomersFilterOption.vue?vue&type=style&index=0&id=e235fb98&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e235fb98"]])

export default __exports__